import React, {useEffect, useState} from 'react'
import { PencilIcon, CheckIcon, XMarkIcon } from "@heroicons/react/24/outline";


export default function InlineEditField({ value, onSave, renderEdit, readOnlyInputClass = "w-full border rounded px-1.5 py-1 pr-10 bg-gray-100 cursor-default text-gray-800" }) {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(value);

  useEffect(() => {
    if(!editing) setDraft(value)
  }, [value, editing])

  function handleSave() {
    setEditing(false);
    if(onSave && draft !== value ) {
      onSave(draft);
    }
  }

  function handleCancel() {
    setDraft(value);
    setEditing(false)
  }

  return (
    <div className="relavtive flex items-center justify-start max-w-md">
      { editing ? (
        <>
          {renderEdit({
            value: draft,
            onChange: setDraft,
            autoFocus: true
          })}
          <span className="isolate inline-flex rounded-md shadow-sm ml-2">
            <button
              type="button"
              className="relative h-5 py-3 inline-flex items-center rounded-l-md bg-white px-1 py-1 text-sm font-semibold text-green-700 ring-1 ring-inset ring-gray-300 hover:bg-green-50 focus:z-10"
              onClick={handleSave}
              aria-label="Save"
            >
              <CheckIcon className="w-4 h-4 mr-1" />
            </button>
            <button
              type="button"
              className="relative -ml-px h-5 py-3 inline-flex items-center rounded-r-md bg-white px-1 py-1 text-sm font-semibold text-red-700 ring-1 ring-inset ring-gray-300 hover:bg-red-50 focus:z-10"
              onClick={handleCancel}
              aria-label="Cancel"
            >
              <XMarkIcon className="w-4 h-4 mr-1" />
            </button>
          </span>
        </>
      ) :
        <>
          <input
            className="w-24 h-4 bg-transparent border-none cursor-default rounded pl-0 pr-3 py-0 bg-white cursor-default text-gray-800 focus:outline-none"
            value={value}
            readOnly
            tabIndex={-1}
          />
          <button
            className="ml-2 right-2 p-1 text-gray-500 hover:text-blue-600"
            onClick={() => setEditing(true)}
            aria-label="Edit"
          >
            <PencilIcon className="w-4 h-4" />
          </button>
        </>
      }
    </div>
  )
}
